import { render, staticRenderFns } from "./MyOrganisation.vue?vue&type=template&id=079dd4e8&scoped=true&"
import script from "./MyOrganisation.vue?vue&type=script&lang=js&"
export * from "./MyOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079dd4e8",
  null
  
)

export default component.exports